function Star1(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="m320 320 160-80-160-80L240 0l-80 160L0 240l160 80 80 160 80-160z"></path></svg>
    )
}

export default Star1